const genericIcon = require('scss/assets/ns-icons/cloud.svg')
const walkerIcon = require('scss/assets/ns-icons/walker.svg')
const busIcon = require('scss/assets/ns-icons/bus.svg')
const trainIcon = require('scss/assets/ns-icons/train.svg')
const shipIcon = require('scss/assets/ns-icons/ship.svg')
const carIcon = require('scss/assets/ns-icons/car.svg')


const COLORS = {
  WHITE: '#FFF',
  DEFAULT: '#888',
  WALKING: '#234045',
  DESTINATION: '#234045'
}

const ICON_NAMES = {
  GENERIC: 'cloud',
  WALKING: 'walker',
  BUS: 'bus',
  TRAIN: 'train',
  SHIP: 'ship',
  CAR: 'car',
  MOTORCYCLE: 'motorcycle',
  TAXI: 'taxi'
};


const ICON_URLS = {
  [ICON_NAMES.GENERIC]: genericIcon,
  [ICON_NAMES.WALKING]: walkerIcon,
  [ICON_NAMES.BUS]: busIcon,
  [ICON_NAMES.TRAIN]: trainIcon,
  [ICON_NAMES.SHIP]: shipIcon,
  [ICON_NAMES.CAR]: carIcon,
  [ICON_NAMES.MOTORCYCLE]: carIcon,
  [ICON_NAMES.TAXI]: carIcon
};

const TRAVEL_MODES = {
  WALKING: 'WALKING',
  TRANSIT: 'TRANSIT'
}

const VEHICLE_TYPES = {
  BUSES: ['BUS', 'INTERCITY_BUS', 'TROLLEYBUS'],
  RAILS: [
    'COMMUTER_TRAIN', 'FUNICULAR', 'HEAVY_RAIL', 'HIGH_SPEED_TRAIN', 'METRO_RAIL', 'MONORAIL',
    'RAIL', 'SUBWAY', 'TRAM'
  ],
  MARITIME: ['FERRY', 'GONDOLA_LIFT'],
  CAR: ['SHARE_TAXI'],
  MOTORCYCLE: ['SHARE_TAXI'],
  TAXI: ['SHARE_TAXI']
}

export {
  COLORS,
  ICON_NAMES,
  ICON_URLS,
  TRAVEL_MODES,
  VEHICLE_TYPES,
  carIcon
}
